import React from 'react'
import _ from 'lodash'

const Reviews = props => {
  console.log(props.user)
  const reviews = _.get(props.user, 'userProfile.reviews', [])
  return (
    <div style={{ borderTop: '1px solid #ccdfe8' }}>
      <h4 className="guru-profile__section-title">Reviews</h4>
      {reviews.length ? ( //styled revews, without correct propnames
        reviews.map((review, index) => (
          <div className="guru-profile__review-block" key={index}>
            <div className="guru-profile__review-header">
              <img src={review.user.userProfile.imageAvatar.url} alt="" style={{ borderRadius: '50%', overflow: 'hidden' }} />
              <div className="guru-profile__review-title">
                <div className="guru-profile__review-user-name">{`${review.user.userProfile.firstName} ${
                  review.user.userProfile.lastName
                }`}</div>
                <div className="guru-profile__review-date">{review.date}</div>
              </div>
            </div>
            <div className="guru-profile__review-body">{review.description}</div>
          </div>
        ))
      ) : (
        <div>No reviews</div>
      )}
    </div>
  )
}

export default Reviews



// WEBPACK FOOTER //
// src/components/Guru/Reviews.js